<template>
  <div class="collapse" style="height:100%;padding:20px">
    <div class="tab-plan-wrapper">
      <!-- <el-tabs v-for="(item,index) in msgPlanList" :key="index" v-model="activePlanName" @tab-click="handlePlanTabClick">
        <el-tab-pane :label="item" :name="item">
        </el-tab-pane>
      </el-tabs> -->
      <!-- <el-scrollbar style="width: 100%;font-size: 12px;position: relative;"> -->
        <!-- <el-tabs v-model="activePlanId" @tab-click="handlePlanTabClick">
          <el-tab-pane v-for="(item,index) in msgPlanList" :key="index" :label="item.planName" :name="item.planId"></el-tab-pane>
        </el-tabs> -->
      <!-- </el-scrollbar> -->
      <el-scrollbar style="width: 100%;height:50px">
        <ul class="tab-list" style="flex: 1">
          <li v-for="(item,index) in msgPlanList" :key="index" :class="activeTab.planId == item.planId ? 'tab-item tab-item-active':'tab-item'" @click="handlePlanTabClick(item)">{{item.planName}}</li>
        </ul>
      </el-scrollbar>
      <div style="display:block;width:100px">
        <span v-show="currentPushList.length">
          <el-button v-if="activeTab.stopStatus" size="small" type="info" style="height:32px;margin-left:20px" disabled>已终止</el-button>
          <el-button v-else size="small" type="primary" style="height:32px;margin-left:20px" @click="quitPlan">终止计划</el-button>
        </span>
      </div>
    </div>
    <el-scrollbar v-if="currentPushList && currentPushList.length" style="height: 100%;font-size: 12px;position: relative;padding-bottom:30px;">
      <div class="plan-detail-wrapper" v-for="(item,index) in currentPushList" :key="index">
        <div class="plan-detail-time">
          <span>{{item.pushTime}}</span>
          <span v-if="item.pushStatus == 2" class="send-tag yet-send">已发</span>
          <span v-if="item.pushStatus == 0" class="send-tag no-send">未发</span>
          <span v-if="item.pushStatus == 3" class="send-tag cancel-send">已取消</span>
          <span v-if="item.pushStatus == 4" class="send-tag no-send">失败</span>
          <span class="plan-name">{{item.templateTypeName}}</span>
        </div>
        <div class="plan-detail-card">
          <div class="detail-row">
            <div>模版名称</div>
            <div style="flex:1">{{item.templateName}}</div>
          </div>
          <div class="detail-row">
            <div>模版说明</div>
            <div style="flex:1">{{item.templateDescribe}}</div>
          </div>
          <div class="detail-row">
            <div>消息模板ID</div>
            <div>{{item.templateId}}</div>
          </div>
          <div v-if="item.templateTypeName == '公众号消息'" class="detail-row">
            <div>提示说明</div>
            <div style="flex:1">
              <!-- {{item.describe}} -->
              <p v-for="(item1,index1) in JSON.parse(item.describe)" :key="index1">
                 {{item1.title}}：{{item1.value}}
              </p>
            </div>
          </div>
          <div v-else class="detail-row">
            <div>提示说明</div>
            <div style="flex:1">{{item.describe}}</div>
          </div>
          <div class="detail-row">
            <div>IM文案</div>
            <div style="flex:1">{{item.msgBody}}</div>
          </div>
        </div>
      </div>
      <div v-if="newestList.length < 20" style="font-size:12px;color:#ccc;text-align:center;margin-top:50px;margin-bottom:30px">
        人家是有底线的~
      </div>
      <div v-else class="al-task" @click="loadPushPlanItem">
        <span>加载更多<i class="el-icon-arrow-down"></i></span>
      </div>
    </el-scrollbar>
    <div v-else class="empty-plan">
      <img src="@/views/treatment/static/empty.png" />
    </div>
    <el-dialog
      title="终止计划"
      :visible.sync="quitDialogVisible"
      width="530px"
      center>
      <div class="quit-tips">确定终止该患者的“{{activeTab.planName}}”？</div>
      <div class="quit-select-wrapper">
        <el-radio-group v-model="stopStrategy" @change="changeStrategy">
          <el-radio :label="1">持续一段时间不匹配该计划</el-radio>
          <el-radio :label="2">后续继续匹配该计划</el-radio>
        </el-radio-group>
      </div>
      <div class="days-quit" v-show="stopStrategy == 1">
        该患者持续
        <el-input placeholder="请输入" v-model="day" style="width:110px" size="small" maxlength="6">
          <template slot="append">天</template>
        </el-input>
        不匹配该计划
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quitDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmQuit" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryPatientPushList,stopPushPlanForPatient,queryPushJobList } from "@/api/Patientmanagement";
export default {
  props: {
    
  },
  data() {
    return {
      stopStrategy: 1,
      day: null,
      quitDialogVisible: false,
      activeName: 'second',
      tabPosition: 'first',
      drawer: false,
      msgPlanList: [
        // '消息计划名称1','消息计划名称2','消息计划名称3'
      ],
      currentPushList: [],
      current: 1,
      activeTab: {
        planId: ''
      },
      newestList: []
    };
  },
  watch: {},
  created() {
    this.getMsgPlanList()
  },
  methods: {
    changeStrategy() {
      this.day = null
    },
    async confirmQuit() {
      let dayReg = /^[0-9]\d*$/
      if (this.stopStrategy == 1 && !this.day) {
        this.$message.error('请输入天数')
        return
      }
      if (this.stopStrategy == 1 && this.day && !dayReg.test(this.day)) {
        this.$message.error('请输入整数')
        return
      }
      let res = await stopPushPlanForPatient({
        day: this.day,
        patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId,
        planId: this.activeTab.planId,
        stopStrategy: this.stopStrategy
      })
      if (res.code == 0) {
        this.$message.success('成功')
        this.quitDialogVisible = false
        // this.activeTab.stopStatus = true
        this.$set(this.activeTab,'stopStatus',true)
      }
    },
    handlePlanTabClick(item) {
      this.activeTab = item
      this.current = 1
      this.newestList = []
      this.currentPushList = []
      this.getMsgList()
    },
    quitPlan() {
      this.day = null
      this.quitDialogVisible = true
    },
    // 获取横向计划title
    async getMsgPlanList() {
      let res = await queryPushJobList(JSON.parse(sessionStorage.getItem('patientInfo')).patientId)
      if (res.code == 0) {
        if (res.data) {
          this.activeTab = res.data[0]
          this.getMsgList()
          this.msgPlanList = res.data
        }
      }
    },
    loadPushPlanItem() {
      this.current++
      this.getMsgList()
    },
    // 获取计划下的推送消息
    async getMsgList() {
      let res = await queryPatientPushList(
        {
          current: this.current,
          patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId,
          planId: this.activeTab.planId,
          size: 20
        }
      )
      if (res.code == 0) {
        res.data = res.data ? res.data : []
        this.newestList = res.data
        this.currentPushList = this.currentPushList.concat(res.data)
      }
    }
  }
};
</script>
<style lang="less" scoped>
.tab-plan-wrapper {
  display: flex;
  justify-content: space-between;
  /deep/.el-tabs {
    margin-right: 30px;
  }
  /deep/.el-tabs__header {
    margin: 0;
  }
}
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}
.top-radio-tab {
  /deep/.el-radio-button__inner {
    padding: 0;
    width: 100px;
    height: 34px;
    line-height: 34px;
  }
}
.tab-list {
  display: flex;
  height: 40px;
  .tab-item {
    font-size: 14px;
    color: #333333;
    margin-right: 30px;
    cursor: pointer;
    // flex: 1;
    // width: max-content;
    white-space: nowrap;
    line-height: 40px;
  }
  .tab-item-active {
    color: #1A7BFC;
    border-bottom: 2px solid #1A7BFC;
  }
}
// 数据加载完成或未完成提示
.al-task {
  color: #1a7bfc;
  text-align: center;
  margin: 16px 0;
  cursor: pointer;
}
.plan-detail-wrapper {
  margin-top: 30px;
  .plan-detail-time {
    span {
      display: inline-block;
      margin-right: 8px;
    }
    .send-tag {
      border-radius: 8px;
      font-size: 12px;
      font-weight: 600;
      text-align: center;
      padding: 2px 7px;
    }
    .yet-send {
      // width: 38px;
      // height: 15px;
      background: #DCEBFF;
      color: #1A7BFC;
    }
    .cancel-send {
      background: #9F9F9F;
      color: #FFFFFF;
      // text-align: center;
    }
    .no-send {
      // width: 38px;
      // height: 15px;
      background: #FFDCDC;
      color: #D75858;
    }
    span:nth-child(1) {
      font-size: 14px;
      font-weight: 600;
      color: rgba(0,0,0,0.85);
    }
    .plan-name {
      font-size: 14px;
      color: rgba(0,0,0,0.85);
    }
  }
  .plan-detail-card {
    background: #F8F8F8;
    border-radius: 6px;
    padding: 15px;
    // padding-bottom: 0;
    margin-top: 10px;
    .detail-row {
      display: flex;
      margin-bottom: 15px;
      div:nth-child(1) {
        margin-right: 20px;
        text-align: right;
        width: 72px;
      }
    }
    .detail-row:last-child {
      margin-bottom: 0;
    }
    div {
      font-size: 14px;
      color: rgba(0,0,0,0.85);
    }
  }
}
.quit-tips {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  line-height: 22px;
  text-align: center;
  margin-bottom: 34px;
}
.quit-select-wrapper {
  text-align: center;
}
.days-quit {
  margin-top: 20px;
  padding-left: 54px;
  /deep/.el-input-group__append {
    padding: 0 10px;
  }
}
.empty-plan {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>

